import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageContentCard } from '../components';
import { BackLink } from 'enrollment/components';
import { usePageContentQuery } from 'enrollment/queries/usePageContentQuery';

function removeEmptyParagraphs(htmlContent: string): string {
  // This regular expression matches <p> tags that contain only a <br> tag, with optional leading/trailing spaces
  // The \s* matches any number of whitespace characters, including none
  return htmlContent.replace(/<p[^>]*>\s*<br\s*\/?>\s*<\/p>/gi, '');
}
export const ViewAllBenefits = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('pages.benefitsInformation');

  // the below query will pull from cache based on 'dashboard/initial' as the id
  const { pageContent, isFetchingPageContent, isLoadingPageContent } =
    usePageContentQuery({ pageContentLookupCode: 'dashboard/initial' });
  const isLoadingContentBlocks = isFetchingPageContent || isLoadingPageContent;
  const contentBlocks = pageContent?.data.content_blocks;

  const showViewAllLink = contentBlocks && contentBlocks.length > 3;
  useEffect(() => {
    if (!isLoadingContentBlocks && !showViewAllLink) {
      navigate(`/`);
    }
  }, [contentBlocks, isLoadingContentBlocks, navigate, showViewAllLink]);

  window.scrollTo({
    top: 0,
    behavior: 'instant',
  });

  return (
    <Box data-testid="view-all-benefits" className="tablet">
      <div>
        <div>
          <BackLink
            underline={false}
            testId="back-button"
            className="mb-5"
            defaultPath="/"
          />
        </div>
        <h1 className="sub-page">{t('title')}</h1>
        {contentBlocks &&
          contentBlocks.slice(1).map((contentBlock) => {
            const processedContent = removeEmptyParagraphs(
              contentBlock.content || ''
            );

            return (
              <PageContentCard
                key={contentBlock.slot_num}
                slotNum={contentBlock.slot_num}
                iconImage={contentBlock.icon_image}
                content={processedContent}
                label={contentBlock.label}
                documents={contentBlock.documents}
                extraClass="benefits-info"
              />
            );
          })}
      </div>
    </Box>
  );
};
